'use strict';

const $window = $(window);
const $document = $(document);
const $body = $('body');
const $html = $('html');

let wW = $window.outerWidth();
let wH = $window.outerHeight();
let dH = $document.outerHeight();

$(document).ready(function () {
    $window
        .on('resize', function () {
            wW = $window.outerWidth();
            wH = $window.outerHeight();
            dH = $document.outerHeight();
        });

    Navigation.init();
    Component.init();

    // $('img[data-src]').lazyload({ data_attribute: 'src', effect : 'fadeIn' });

    // Add your code here
    $('[data-go-to-form]').on('click', function(){
        Navigation.helpers.scrollTo($('[data-component="sections/register"]').offset().top - 50);
    });

    // var maskBehavior = function (val) {
    //     return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
    // },
    // options = {onKeyPress: function(val, e, field, options) {
    //     field.mask(maskBehavior.apply({}, arguments), options);
    //     }
    // };

    // $('.input-tel').mask(maskBehavior, options);

    $('.input-tel').mask('+55 (00) 00000-0000');

    Navigation.on('./', () => {
        Navigation.helpers.scrollTo(0);
    });

    const scrollToPage = (url) => Navigation.helpers.scrollTo(url);

    //Navigation.on('sanduicones/', scrollToPage);

    $window.trigger('resize').trigger('popstate');

    $window
        .on('scroll', function () {
            Animator.onScroll();
            if (typeof Navigation !== 'undefined') { Navigation.onScroll(); }
        })
        .trigger('scroll');
});
